let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("iPJim")]).then(() => parcelRequire('7iUqh'));